import { createSelector } from 'reselect'
import lessonSources from 'helpers/enums/lessonSources'

const lessonsSelector = state => state.lessons
const qsSelector = state => state.qs

export default createSelector(
	[ lessonsSelector, qsSelector ],
	(lessons, qs) => {
		const lessonKeys = Object.keys(lessons)
		const lessonKey = lessonKeys.find(key =>
			lessons[key].data.sourceInfo.payload.id === qs.presentationId &&
			lessons[key].data.sourceInfo.type === lessonSources.GOOGLE_SLIDES)
		let lesson
		if (lessonKey) {
			lesson = lessons[lessonKey]
		}
		return lesson
	}
)
